import { Schema } from "@comparaonline/marketplace-schema";
import React from "react";
import { Query, QueryProps } from "react-apollo";
import { getLandingTitle } from "./getLandingTitle";

export type LandingData = Pick<Schema.Query, "landing">;
type LandingArguments = Schema.LandingQueryArgs;

class BaseQuery extends Query<LandingData, LandingArguments> {}

export interface ILandingQueryProps
  extends Pick<QueryProps<LandingData, LandingArguments>, "children"> {
  variables: LandingArguments;
}

export const LandingQuery: React.FC<ILandingQueryProps> = ({ children, variables }) => (
  <BaseQuery query={getLandingTitle} variables={variables}>
    {data => children(data)}
  </BaseQuery>
);
